import {
    COMPANY_ADMIN_ORGANIZATION_USERS_ROUTE,
    COMPANY_ADMIN_ROUTE,
    TENANT_ADMIN_ROUTE,
    TENANT_USERS_ROUTE,
} from "../../../../../../constants/routes"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import { userType } from "../helpers/userType"

type UserType = ReturnType<typeof userType>

type UserTypeConfig = {
    [K in UserType]: {
        queryKey: string
        onSuccessUrl: string
        homeUrl: string
        breadcrumbUrl: string
        page: Page
    }
}

export const userTypeConfig: UserTypeConfig = {
    tenant: {
        queryKey: "users-for-tenant",
        onSuccessUrl: `${TENANT_USERS_ROUTE}?tab=user`,
        homeUrl: TENANT_ADMIN_ROUTE,
        breadcrumbUrl: TENANT_USERS_ROUTE,
        page: Page.TENANT_CREATE_USER,
    },
    company: {
        queryKey: "company-organization-users",
        onSuccessUrl: COMPANY_ADMIN_ORGANIZATION_USERS_ROUTE,
        homeUrl: COMPANY_ADMIN_ROUTE,
        breadcrumbUrl: COMPANY_ADMIN_ORGANIZATION_USERS_ROUTE,
        page: Page.COMPANY_USERS_CREATE_USER,
    },
}
